import { Card } from '@reveni-io/reveni-ui'

import CustomerNotesCardContent from './CustomerNotesCardContent/CustomerNotesCardContent'
import CustomerNotesCardHeader from './CustomerNotesCardHeader/CustomerNotesCardHeader'

const CustomerNotesCard = ({ data, refetch, onExport, exporting, onClickTopic }) => {
  return (
    <Card showBorder={false}>
      <CustomerNotesCardHeader onExport={onExport} exporting={exporting} />
      <CustomerNotesCardContent data={data} refetch={refetch} onClickTopic={onClickTopic} />
    </Card>
  )
}

export default CustomerNotesCard
